<template>
  <div class="d-flex flex-column shop-quantity pb-2">
    <Calendar
      class="w-100 form-control-sm px-0"
      style="min-width: 120px;max-width: 125px;"
      showButtonBar
      showIcon
      inputClass="w-100 small"
      dateFormat="mm/dd/yy"
      v-model="formCart.order_future_date"
      :minDate="minFutureDate"
      :maxDate="maxFutureDate"
      v-if="inToolFair2023()"
    />
    <label v-if="labelText" for="qty" class="col-form-label mr-2 text-nowrap font-weight-bold text-primary qty-label">{{labelText}}</label>
    <div class="d-flex align-items-center justify-content-start justify-content-xl-end"
         style="min-width: 120px;max-width: 125px;"
    >
      <button 
        v-if="productQty > 0 && !qtyUserInput"
        class="btn btn-danger btn-sm widget-icon left ml-0 mr-1"
        :class="inputStyle"
        @click="decrementItem(product)"
      >
        <i v-if="productQty == 1" class="fa fa-trash" />
        <i v-else class="fa fa-minus" /> 
      </button>
      <input 
        ref="product-quantity"
        @change="updateQuantity(product)"
        @input="qtyUserInput = true"
        type="text"
        id="qty"
        class="form-control custom-form-inline h-100 qty-input"
        :class="inputStyle"
        v-model="formCart.qty"
      />
      <button 
        class="btn btn-success btn-sm widget-icon right ml-1"
        :class="inputStyle"
        @click="updateQuantity(product, true)"
      >
        <i v-if="productQty > 0 && !qtyUserInput" class="fas fa-plus" />
        <i v-else class="fas fa-cart-plus"/>
      </button>
    </div>
  </div>
</template>

<script>
  import Calendar from 'primevue/calendar'
  export default {
    components: {
      Calendar,
    },
    data() {
      return {
        qtyUserInput: false,
        formCart: this.$inertia.form({
          item_id: null,
          product_id: null,
          variation_product_id: null,
          qty: null,
          is_suggested: this.is_suggested,
          order_future_date: null,
          suggested_type: this.suggested_type
        }),
        minFutureDate: new Date(moment()),
        maxFutureDate: new Date(moment().add(8, 'month')),
      }
    },
    props: {
      product: [Object, Number, Boolean],
      variation_product: Object,
      routes: Object,
      inputStyle: String,
      cart_items: Array,
      labelText: String,
      is_suggested: {
        type: Boolean,
        default: false
      },
      suggested_type: {
        type: String,
        default: null
      },
    },
    mounted() {
      this.refresh()
    },
    computed: {
      productQty() {
        const cartItem = this.findItemFromCart(this.product)
        if (cartItem) return cartItem.linked_qty
        return 0
      }
    },
    methods: {
      refresh() {
        const cartItem = this.findItemFromCart(this.product)
        this.formCart.qty = cartItem ? cartItem.linked_qty : 1
        if (cartItem) {
          if (cartItem.future_items.length > 0 && this.formCart.qty == 0) {
            // show the last default qty if main zero qty
            const last = cartItem.future_items.sort((a,b) => a.updated_at > - b.updated_at ? -1 : (a.updated_at <  b.updated_at ? 1 : 0))[0]
            this.formCart.qty = last.qty
            this.formCart.order_future_date = new Date(last.order_future_date)
          }
        } else {
          this.formCart.order_future_date = null
        }
        this.qtyUserInput = false
      },
      findTrueItemFromCart(product) {
        for (let i = 0; i < this.cart_items.length; i++) {
          if (this.cart_items[i].variation_option_product_id && this.cart_items[i].product.id === (product.id || product.product_id)) {
            if (this.cart_items[i].variation_option_product_id == product.variation_product_id) {
              return this.cart_items[i]
            } else if (this.variation_product && this.cart_items[i].variation_option_product_id == this.variation_product.id) {
              return this.cart_items[i];
            }
          } else if (this.cart_items[i].product.id === (product.id || product.product_id)) {
            return this.cart_items[i]
          }
        }
      },
      findItemFromCart(product) {
        const cartItem = this.findTrueItemFromCart(product);
        if (this.formCart.order_future_date && cartItem) {
          cartItem.qty = cartItem.future_items.filter(v => (new Date(v.order_future_date)).getTime() === (new Date(this.formCart.order_future_date)).getTime())[0]?.qty || ''
          cartItem.linked_qty = cartItem.qty
        }
        return cartItem;
      },
      add(product) {
        if (this.formCart.processing) return

        let qty = parseInt(this.formCart.qty)
        this.formCart.qty = qty || 1,
        this.formCart.product_id = product.id || product.product_id
        this.formCart.variation_product_id = product.variation_product_id ? product.variation_product_id : this.variation_product ? this.variation_product.id : null;

        this.formCart.post(this.route(this.routes.add, product.id || product.product_id), { 
          preserveScroll: true,
          onSuccess: () => { 
            this.$emit('updateCartItems')
            this.formCart.order_future_date = null
            this.trackAddToCart(
              product,
              this.formCart.qty,
              this.$page.props
            );
          }
        })
      },
      updateQuantity(product, increment=false, decrement=false) {
        if (this.formCart.processing) return
          
        const cartItem = this.findItemFromCart(product)

        if (cartItem) {
          let old_quantity = cartItem.qty;
          let qty = parseInt(this.formCart.qty)
          if (qty < 1) {
            this.deleteItem(product)
            return
          }
          if (old_quantity == '' && qty == 1) {
            qty = 0
          }
          this.formCart.item_id = cartItem.cart_item_id
          if (!this.qtyUserInput) {
            if (increment) this.formCart.qty = qty + 1
            else if (decrement) this.formCart.qty = qty - 1
          }
          this.formCart.product_id = product.id || product.product_id

          let new_quantity = this.formCart.qty;

          this.formCart.post(this.route(this.routes.update), { 
            preserveScroll: true,
            onSuccess: () => { 
              this.$emit('updateCartItems')

              this.trackCartQuantityUpdate(
                product,
                old_quantity,
                new_quantity,
                this.$page.props
              );
            }
          })
        } else this.add(product)
      },
      decrementItem(product) {
        if (parseInt(this.formCart.qty) <= 1) this.deleteItem(product)
        else this.updateQuantity(product, false, true)
      },
      deleteItem(product) {
        if (this.formCart.processing) return
          
        let cartItem = this.findItemFromCart(product)

        this.formCart.item_id = cartItem.cart_item_id
        this.formCart.product_id = product.id || product.product_id
        this.formCart.qty = 1

        this.formCart.post(this.route(this.routes.delete), { 
          preserveScroll: true,
          onSuccess: () => { 
            this.$emit('updateCartItems')
            this.refresh()
            this.trackCartQuantityUpdate(
              product,
              cartItem.qty,
              0,
              this.$page.props
            );
          }
        })
      },
    },
    watch: {
      'formCart.order_future_date'(val) {
        const cartItem = this.findItemFromCart(this.product)
        if (cartItem) {
          this.formCart.qty = cartItem.qty || 1
        }
        if (val && val > moment(val).startOf('date').toDate()) {
          val = moment(val).startOf('date').toDate()
          this.formCart.order_future_date = val
        }
      },
      product() {
        this.refresh()
      },
      cart_items() {
        this.refresh()
      }
    }
  }
</script>
<style lang="scss">
.shop-quantity .p-calendar .p-datepicker-trigger {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.shop-quantity .p-calendar {
  max-height: 34px;
}
</style>
